import type { ChatSession } from "@stockline/shared/types/ai/chat-session"
import type { OfflineResourceConfig } from "../../../types"
import { CHAT_SESSION_TABLE } from "./db"

export const chatSessionConfig: OfflineResourceConfig<ChatSession> = {
  name: "chat-sessions",
  endpoints: {
    full: "/api/v2/chat-sessions",
    delta: "/api/v2/chat-sessions/changes",
    push: "/api/v2/chat-sessions/changes",
  },
  tableName: CHAT_SESSION_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    userId: "userId",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
